<template>
  <div class="trackWrap page_text_font" id="trackWrap">
    <div class="trackSearchForm">
      <h1 class="trackTitle title_font2">{{ $t('track.track_your_order') }}</h1>
      <div class="trackFormIn">
        <div class="trackFormOrder">
          <div class="formItem">
            <input
              type="text"
              id="number"
              name="number"
              v-model="trackPara.number"
              @blur="required"
              :placeholder="$t('track.order_number')"
            />
            <span class="clear" v-if="trackPara.number" @click="clearVal('number')">x</span>
            <div class="error">
              {{ $t('track.order_number_cannot_be_empty') }}
            </div>
          </div>
          <div class="formItem">
            <input
              type="text"
              id="trackemail"
              name="email"
              v-model="trackPara.email"
              @blur="required($event, 'email')"
              :placeholder="$t('comment.email')"
            />
            <span class="clear" v-if="trackPara.email" @click="clearVal('email')">x</span>
            <div class="error">
              {{ $t('track.email_address_cannot_be_empty') }}
            </div>
          </div>
          <div class="formItem">
            <button @click="getTrack(1)" class="main_button">
              {{ $t('track.track') }}
            </button>
          </div>
        </div>
        <hr />
        <div class="trackLine">
          <div class="line"></div>
          <div class="word">{{ $t('shopping.or') }}</div>
          <div class="line"></div>
        </div>
        <div class="trackFormNumber">
          <div class="formItem">
            <input
              type="text"
              id="tracknum"
              name="tracknum"
              v-model="trackPara.tracknum"
              @blur="required"
              :placeholder="$t('track.tracking_number') + ' (e.g.1141303821053)'"
            />
            <span class="clear" v-if="trackPara.tracknum" @click="clearVal('tracknum')">x</span>
            <div class="error">
              {{ $t('track.waybill_number_cannot_be_empty') }}
            </div>
          </div>
          <div class="formItem">
            <button @click="getTrack(2)" class="main_button">
              {{ $t('track.track') }}
            </button>
          </div>
        </div>
      </div>
      <div class="trackBelow" v-if="customer_service_email">
        {{ $t('track.contact_us') }}
        <a :href="'mailto:' + customer_service_email">{{ customer_service_email }}</a>
      </div>
    </div>
    <div class="trackSearchResult" :class="{ button_active: loading }">
      <div class="hasFind" :style="{ opacity: loading ? '0.2' : '1' }" v-if="(order || track) && SearchOnOff">
        <h2 v-if="order_id">{{ $t('track.order') }} #{{ order_id }}</h2>
        <h2 v-else>{{ $t('track.logistics_information') }}</h2>
        <div class="processBar">
          <v-timebar :timebar="timebar"></v-timebar>
        </div>
        <div class="processDetail">
          <div class="trackRight">
            <ul class="trackInfoParent">
              <li>
                <div class="trackInfoTitle">
                  {{ $t('track.expected_delivery_date') }}
                </div>
                <div class="trackInfo">
                  {{ timebar.OutForDelivery || $t('track.unknown') }}
                </div>
              </li>
              <li v-if="carrier_code">
                <div class="trackInfoTitle">{{ $t('track.carrier') }}</div>
                <div class="trackInfo clearfix">
                  <div class="carrierImg">
                    <img :src="`//s.51tracking.com/images/icons/express/${carrier_code}.png`" alt="" />
                  </div>
                  <div class="carrierMes">
                    <div class="trackName">{{ carrier_code }}</div>
                    <div class="trackPhone">{{ carrier_phone }}</div>
                  </div>
                </div>
              </li>
              <li v-if="tracking_number">
                <div class="trackInfoTitle">{{ $t('track.tracking_number') }} (e.g. 1234)</div>
                <div class="trackInfo">{{ tracking_number }}</div>
              </li>
              <li v-if="porducts_line_items.length">
                <div class="trackInfoTitle">{{ $t('track.product') }}</div>
                <div class="trackInfo">
                  <v-trackporducts :porducts_line_items="porducts_line_items"></v-trackporducts>
                </div>
              </li>
            </ul>
          </div>
          <div class="trackLeft">
            <h2 class="title_font2">{{ $t('track.status') }} : {{ translateState(trackstatus) }}</h2>
            <v-timeline :theme="theme" :trackinfo="trackinfo"></v-timeline>
          </div>
        </div>
      </div>
      <h2 class="notFind" :style="{ opacity: loading ? '0.2' : '1' }" v-else-if="SearchOnOff">
        {{ $t('track.not_find') }}
      </h2>
    </div>
  </div>
</template>
<script>
import vTimeline from './timeline'
import vTimebar from './timebar'
import vTrackporducts from './trackproducts'
// import API from '../../../API'
export default {
  props: ['theme', 'customer_service_email', 'order_tracking'],
  data() {
    return {
      trackPara: {
        email: '',
        number: '',
        tracknum: '',
      },
      track_message: {},
      trackinfo: [],
      trackstatus: '',
      carrier_code: '',
      carrier_phone: '',
      tracking_number: '',
      porducts_line_items: [],
      timebar: {
        Ordered: '',
        InProcess: '',
        OrderReady: '',
        InTransit: '',
        OutForDelivery: '',
        Delivered: '',
      },
      order_id: '',
      SearchOnOff: false,
      order: null,
      track: null,
      loading: false,
    }
  },
  mounted() {
    let tracknum = this.getSearch('tracknum')
    if (tracknum) {
      this.$('#tracknum').val(tracknum)
      this.trackPara.tracknum = tracknum
      this.getTrack(2)
    }
  },
  methods: {
    translateState(state) {
      state = state ? state : 'notfound'
      switch (state) {
        case 'pending':
          return this.$t('track.pending')
        case 'notfound':
          return this.$t('track.notfound')
        case 'transit':
          return this.$t('track.transit')
        case 'pickup':
          return this.$t('track.pickup')
        case 'delivered':
          return this.$t('track.delivered')
        case 'expired':
          return this.$t('track.expired')
        case 'undelivered':
          return this.$t('track.undelivered')
        case 'exception':
          return this.$t('track.exception')
        default:
          return state
      }
    },
    clearVal(key) {
      this.trackPara[key] = ''
    },
    text_required(arr) {
      let onOff = true
      let reg = /^([0-9A-Za-z\-_\.]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      arr.forEach((item) => {
        let target = this.$(`.trackWrap input[name=${item}]`)
        if (
          target.length &&
          (!target.val() || (item == 'tracknum' && (target.val().length < 5 || target.val().length > 50))||(item == "email" && !reg.test(target.val())))
        ) {
          onOff = false
          target.parent().addClass('formItemError')
        } else {
          target.parent().removeClass('formItemError')
        }
      })
      console.log(onOff)
      return onOff
    },
    required(e, param) {
      let { value, name } = e.target
      let reg = /^([0-9A-Za-z\-_\.]+)@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      console.log(value, name, 'aaaaa')
      if (!value || (name == 'tracknum' && (value.length < 5 || value.length > 50))||(param == "email" && !reg.test(e.target.value))) {
        this.$(e.target).parent().addClass('formItemError')
      } else {
        this.$(e.target).parent().removeClass('formItemError')
      }
    },
    reset_track() {
      this.trackinfo = []
      this.trackstatus = ''
      this.trackinfo = []
      this.trackstatus = ''
      this.carrier_code = ''
      this.carrier_phone = ''
      this.tracking_number = ''
      this.porducts_line_items = []
      this.timebar = {
        Ordered: '',
        InProcess: '',
        OrderReady: '',
        InTransit: '',
        OutForDelivery: '',
        Delivered: '',
      }
      this.order_id = ''
      this.order = null
      this.track = null
    },
    async getTrack(type) {
      if (this.loading) return
      try {
        this.loading = true
        let params =
          type == 1
            ? { email: this.trackPara.email, number: this.trackPara.number }
            : { tracknum: this.trackPara.tracknum }
        params.type = type
        if (this.text_required(Object.keys(params))) {
          let res = await this.$axios.get(this.order_tracking ? API.order_tracking : API.track, { params })
          this.reset_track()
          this.SearchOnOff = true
          this.track_message = res.data
        }
        this.loading = false
      } catch (error) {
        this.reset_track()
        this.loading = false
        this.SearchOnOff = true
      }
    },
  },
  watch: {
    track_message: {
      handler(newV) {
        let { track, order } = newV
        if (order) {
          this.order = order
          this.order_id = order.ID
          this.timebar.Ordered = order.post_date
          this.timebar.InProcess = order.track_date
          if (order.line_items && order.line_items.length) {
            this.porducts_line_items = order.line_items
          }
        }
        if (track) {
          this.track = track
          this.trackstatus = track.status
          this.tracking_number = track.tracking_number
          let { origin_info } = track
          if (origin_info) {
            this.timebar.OrderReady = origin_info.ItemReceived
            this.carrier_code = origin_info.carrier_code
            this.carrier_phone = origin_info.phone
            let { trackinfo } = origin_info
            if (trackinfo && trackinfo.length) {
              let onOff = true
              trackinfo.forEach((item) => {
                switch (item.checkpoint_status) {
                  //第一个一个状态为transit为InTransit时间,加开关处理;
                  case 'transit':
                    this.timebar.InTransit = onOff ? item.Date : this.timebar.InTransit
                    onOff = false
                    return
                  case 'pickup':
                    this.timebar.OutForDelivery = item.Date
                    return
                  case 'delivered':
                    this.timebar.Delivered = item.Date
                    return
                  default:
                    break
                }
              })
              this.trackinfo = trackinfo
            }
          }
        }
      },
      deep: true,
    },
  },

  components: {
    vTimeline,
    vTimebar,
    vTrackporducts,
  },
}
</script>
<style scoped lang='scss'>
* {
  text-align: left;
}
ul {
  li {
    list-style: none;
  }
}
.trackWrap {
  padding-bottom: 100px;
  .trackSearchForm {
    .trackTitle {
      line-height: 42px;
      text-align: center;
      font-size: 30px;
      margin: 50px 0;
      letter-spacing: 2px;
      color: #454545;
      font-weight: 500;
    }
    .trackFormIn {
      border: 1px solid #e6e6e6;
      border-radius: 7px;
      clear: both;
      padding: 30px 20px;
      display: flex;
      hr {
        display: none;
        margin: 15px 0;
      }
      .trackFormOrder,
      .trackFormNumber {
        padding: 3% 10%;
        width: 100%;
      }
      .trackLine {
        padding: 20px 12px 30px;
        width: 6%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .line {
          width: 0px;
          height: 100px;
          border-left: 1px dashed #c4c4c4;
        }
        .word {
          white-space: nowrap;
          margin: 7px 0;
          font-size: 15px;
        }
      }
    }
    .trackBelow {
      text-align: center;
      padding: 20px 0;
      font-size: 15px;
    }
    .formItem {
      position: relative;
      margin-bottom: 22px;
      label {
        vertical-align: middle;
        font-size: 14px;
        color: #606266;
        line-height: 40px;
        padding: 0 12px 0 0;
        box-sizing: border-box;
      }
      input {
        -webkit-appearance: none;
        background-color: #fff;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        margin: 0;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: inherit;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 30px 0 15px;
        transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
        width: 100%;
        &:focus {
          border-color: black;
        }
        &:hover,
        &:focus {
          & + .clear {
            display: inline-block;
          }
        }
      }
      .clear {
        display: none;
        position: absolute;
        top: 13px;
        right: 10px;
        color: #b2b4b8;
        border: 1px solid #b2b4b8;
        border-radius: 50%;
        text-align: center;
        width: 15px;
        height: 15px;
        font-size: 12px;
        line-height: 11px;
        cursor: pointer;
        &:hover {
          display: inline-block;
        }
      }
      .error {
        display: none;
        color: #f56c6c;
        font-size: 12px;
        line-height: 1;
        padding-top: 4px;
      }
      button {
        width: 100%;
        text-align: center;

        background-color: black;
        padding: 10px 18px;
        color: #fff;
        border: 1px solid transparent;
        border-radius: 2px;
        cursor: pointer;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.08em;
        line-height: 15px;
        &:hover {
          opacity: 0.7;
        }
      }
    }
    .formItemError {
      margin-bottom: 5px;
      input {
        border-color: #f56c6c;
      }
      .error {
        display: block;
      }
    }
  }
  .trackSearchResult {
    margin-top: 35px;
    padding: 0 40px;
    .notFind {
      line-height: 100%;
      text-align: center;
      margin-bottom: 15px;
    }
    .hasFind {
      & > h2 {
        line-height: 100%;
        text-align: center;
        margin-bottom: 15px;
      }
      .processDetail {
        display: flex;
        flex-wrap: wrap;
        .trackLeft {
          padding-right: 3%;
          width: 70%;
          h2 {
            font-size: 35px;
            margin: 0;
            padding: 20px 0;
          }
        }
        .trackRight {
          order: 1;
          width: 30%;
          .trackInfoParent {
            li {
              margin-bottom: 40px;
              width: 100%;
              list-style: none;
              .trackInfoTitle {
                font-size: 16px;
                color: #999;
                line-height: 40px;
              }
              .trackInfo {
                line-height: 30px;
                font-size: 16px;
                font-weight: 400;
                .carrierImg {
                  float: left;
                  height: 80px;
                  width: 80px;
                  background-size: 100% 100%;
                  border-radius: 4px;
                  margin-right: 12px;
                  img {
                    max-width: 100%;
                  }
                }
                .carrierMes {
                  float: left;
                }
              }
            }
          }
        }
      }
    }
  }
  .button_active {
    &::after {
      width: 40px !important;
      height: 40px !important;
      border-color: black !important;
    }
  }
}
#trackWrap {
  .button_active {
    color: unset !important;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .trackWrap {
    .trackSearchForm {
      .trackFormIn {
        .trackFormOrder,
        .trackFormNumber {
          padding: 2% 4%;
        }
      }
    }
  }
}

@media screen and(max-width:768px) {
  .trackWrap {
    .trackSearchForm {
      .trackTitle {
        line-height: 29px;
        margin-top: 35px;
        margin-bottom: 22px;
        font-size: 18px;
        letter-spacing: 1px;
      }
      .trackFormIn {
        display: block;
        .trackFormOrder,
        .trackFormNumber {
          padding: 0;
        }
        hr {
          display: block;
        }
        .trackLine {
          display: none;
        }
      }
    }
    .trackSearchResult {
      padding: 0;
      .hasFind {
        .processBar {
          display: none;
        }
        .processDetail {
          .trackRight,
          .trackLeft {
            order: 0;
            width: 100%;
          }
        }
      }
    }
  }
}
</style>